import { render, staticRenderFns } from "./ValuerSelection.vue?vue&type=template&id=156536f4&scoped=true"
import script from "./ValuerSelection.vue?vue&type=script&lang=js"
export * from "./ValuerSelection.vue?vue&type=script&lang=js"
import style0 from "./ValuerSelection.vue?vue&type=style&index=0&id=156536f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156536f4",
  null
  
)

export default component.exports